"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/alert/style/index.js
// module id = 126
// module chunks = 1